module.exports = __webpack_public_path__ + "img/J12686.d2bbf56e.png";